<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0" style="height:100%;">
      <!-- Alert message -->
      <div>
        <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
      </div>
      <!-- main content -->
      <!-- Header Component -->
      <div><HeaderComponent :headerTitle="headerText" :router-link="{ name: 'ReturnCreationRia' }"
        :router-link-text="'Return / Claim Requests'"  :return-condition="true"/>
      </div>
      <v-card class="v-card-100">
        <v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="2" md="2" sm="2" lg="2" class="text-left d-flex m-4">
                <span style="font-size: 14px;">Request Type</span>
              </v-col>
              <v-col cols="4" md="4" sm="4" lg="4">
                <v-autocomplete 
              v-model="createRequest"
              :items="organization_name === 'Blubirch' ? returnTypeList : filteredReturnTypeList"
              item-title="original_code"
              label="Select Request Type"
              solo
              class="ma-2"
              return-object
              variant="outlined"
              :item-props="getItemProps"
              @update:modelValue="navigateToComponent" 
              ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-card>
</template>

<script>
  import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
  export default{
    data(){
      return{
        headerText: "Return Creation",
        alert_type:'success',
        alert_message:'success',
        return_search:'',
        alert: false,
        selected:[],
        returnTypeList: [
        ],
        createRequest: [],
        loading: false,
        page : 1 ,
        totalPages : 1,
        pageSize :  100,
        pageSizes : [50 , 100, 150],
        filteredReturnTypeList: [],
        organization_name: '',
      }
    },
    components: {
      HeaderComponent
    },
    async created() {
      this.loadData();
      this.currentUser = this.$store.state.currentUser.roles[0];
      this.organization_name = this.$store.state.organization_name;
    },
    computed: {
      filteredReturnTypeList() {
        return this.returnTypeList.map(item => {
          if (this.currentUser === 'area_service_manager') {
            if (item.original_code === 'Dealer-Partner Sales Return') {
              return { ...item, disabled: false };
            } else {
              return { ...item, disabled: true };s
            }
          }else if(this.currentUser === 'warehouse_manager'){
          if (item.original_code === 'Undelivered Returns Sales Return') {
            return { ...item, disabled: false };
          } else {
            return { ...item, disabled: true };
          }
          }else{
            return { ...item, disabled: false };
          }
        });
      },
    },
    methods: {
      loadData(){
        this.getrequestTypes();
      },
      getItemProps(item) {
        return { disabled: item.disabled };
      },
        getrequestTypes() {
        const params = this.getRequestParams(this.page, this.pageSize);
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/master_values/return_types")
          .then(response => {
            if (response.data) {
              this.returnTypeList = response.data.lookup_values;
              this.totalPages = 1;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      navigateToComponent() {
        const return_id = this.createRequest.id;
        const return_value = this.createRequest.original_code;
        if (return_value) {
          this.$store.commit("setRequestDetails",{
            items : '',
          });
          this.$store.commit("setLotIds", {
            lotIds: return_id,
            action: return_value
          });
          this.$router.push({ name: 'ReturnCreationRequestRia'}); 
        }
      },
      disableItem(item) {
        return item.original_code === 'Pullback Return';
      },
      getRequestParams(page, pageSize) {
        let params = {};

        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
    }
  }

</script>
<style scoped>
  :deep(.v-card .v-card-100, .v-card__title .v-input__control .v-input__slot) {
    box-shadow: none !important;
  }
  :deep(.v-card__title legend) {
    display: none;
  }
  :deep(.v-card__title fieldset) {
    top: 0px !important;
  }
</style>